import React from 'react';
import { useStyles } from './styles';

export const LoadingDots = () => {
  const classes = useStyles();

  return (
    <span className={classes.loadingDots}>
      <span></span>
      <span></span>
      <span></span>
    </span>
  );
};
